'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _templateObject = _taggedTemplateLiteral(
  ['\n  max-width: ', 'rem;\n'],
  ['\n  max-width: ', 'rem;\n']
)

var _Box = require('./Box')

var _Box2 = _interopRequireDefault(_Box)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var Container = _Box2.default.extend(_templateObject, function(props) {
  return props.maxWidth
})

Container.displayName = 'Container'

Container.propTypes = {
  maxWidth: _propTypes2.default.number
}

Container.defaultProps = {
  maxWidth: 64,
  mx: 'auto'
}

exports.default = Container



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Container.js
// module id = 510
// module chunks = 168707334958949